// extracted by mini-css-extract-plugin
export default {"navBarMenu":"BurgerMenu_navBarMenu__fHz2m","line":"BurgerMenu_line__Wn-k8","navBarMenuOpen":"BurgerMenu_navBarMenuOpen__Sy0MQ"};